// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiURL: 'https://apis-lamienins.arghayc35.dev/api/',
  stripePublishableKey:
    'pk_test_51Ja2fiJ0S5wIFjbHM6qJiUB14jQxDUmzOqpnR9soDAL5EQ4yTItUwSk779HkBBeil9Qe4aOWuIxLE7izlfPdjHZN004aiBqdBj',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
